// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CANCEL = "Zru\u0161";
export const CANCEL_CHANGES = "Zru\u0161 zmeny";
export const CONFIRM = "Potvr\u010f";
export const CONFIRM_PHOTOS = "Potvr\u010f fotky";
